// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W829d","right":"styles_right__39nDm"};